import { render, staticRenderFns } from "./IncomeSummary.vue?vue&type=template&id=2212d374&scoped=true&"
import script from "./IncomeSummary.vue?vue&type=script&lang=js&"
export * from "./IncomeSummary.vue?vue&type=script&lang=js&"
import style0 from "./IncomeSummary.vue?vue&type=style&index=0&id=2212d374&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2212d374",
  null
  
)

export default component.exports